/* eslint-disable import/order */
/* eslint-disable jest/require-hook */
import {
  lgpHeroStickyWidget,
  lgpHeroWidget,
  // lgpResultsContainerWidget,
  lgpResultsWidget,
  matchChangeLmpWidget,
  matchCommentsWidget,
  matchHeroSlimWidget,
  matchHeroWidget,
  matchLineupsFieldsWidget,
  matchLineupsWidget,
  matchPredictedLineupsWidget,
  matchStatisticsWidget,
  playerStatisticsWidget,
} from '@sky-it-livedata/livedata-live-match-pages-widgets';

/* Import Dynamic Components */
import DynamicLgpHeroSticky from './components/lgp-hero-sticky/dynamic-lgp-hero-sticky';
import DynamicLgpHero from './components/lgp-hero/dynamic-lgp-hero';
// import DynamicLgpResultsContainer from './components/lgp-results-container/dynamic-lgp-results-container';
import DynamicLgpResults from './components/lgp-results/dynamic-lgp-results';
import DynamicMatchChangeLmp from './components/match-change-lmp/dynamic-match-change-lmp';
import DynamicMatchComments from './components/match-comments/dynamic-match-comments';
import DynamicMatchHeroSlim from './components/match-hero-slim/dynamic-match-hero-slim';
import DynamicMatchHero from './components/match-hero/dynamic-match-hero';
import DynamicMatchLineups from './components/match-lineups/dynamic-match-lineups';
import DynamicMatchPredictedLineups from './components/match-predicted-lineups/dynamic-match-predicted-lineups';
import DynamicMatchStartupFormations from './components/match-startup-formations/dynamic-match-startup-formations';
import DynamicMatchStatistics from './components/match-statistics/dynamic-match-statistics';
import DynamicPlayerStatistics from './components/player-statistics/dynamic-player-statistics';
import ageCalc from './utils/age-calc';
import { trackPageViews } from './utils/analytics-track';
import { handleLgpTabs } from './utils/handle-lgp-tabs';
import { hydrateTabsMenu } from './utils/hydrate-tabs-menu';
import manageImagePlaceholders from './utils/placeholder-images';
import resumePlayerPages from './utils/resume-player-pages';
import { heroSlimSticky } from './utils/sticky-hero';
import { activeTabScrollIntoView, clickFromHash } from './utils/tabs-utils';
import { defineWebComponents } from './utils/web-components-utils';

const webComponentsMap = new Map();
webComponentsMap.set(matchChangeLmpWidget.tag, DynamicMatchChangeLmp);
webComponentsMap.set(matchCommentsWidget.tag, DynamicMatchComments);
webComponentsMap.set(matchHeroSlimWidget.tag, DynamicMatchHeroSlim);
webComponentsMap.set(matchHeroWidget.tag, DynamicMatchHero);
webComponentsMap.set(matchLineupsFieldsWidget.tag, DynamicMatchStartupFormations);
webComponentsMap.set(matchLineupsWidget.tag, DynamicMatchLineups);
webComponentsMap.set(matchPredictedLineupsWidget.tag, DynamicMatchPredictedLineups);
webComponentsMap.set(matchStatisticsWidget.tag, DynamicMatchStatistics);
webComponentsMap.set(playerStatisticsWidget.tag, DynamicPlayerStatistics);
webComponentsMap.set(lgpHeroWidget.tag, DynamicLgpHero);
webComponentsMap.set(lgpHeroStickyWidget.tag, DynamicLgpHeroSticky);
// webComponentsMap.set(lgpResultsContainerWidget.tag, DynamicLgpResultsContainer);
webComponentsMap.set(lgpResultsWidget.tag, DynamicLgpResults);

defineWebComponents(webComponentsMap);

manageImagePlaceholders();

document.addEventListener('DOMContentLoaded', () => {
  ageCalc();
  resumePlayerPages();
  heroSlimSticky();
  hydrateTabsMenu();
  handleLgpTabs();
  activeTabScrollIntoView();
  clickFromHash();
});

window.addEventListener('player_page_statistic_loaded', () => {
  trackPageViews();
});
